// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"4889d80a","969":"6ed8ca0b"}[chunkId] + ".chunk.css";
};